<template>
  <q-drawer side="right" v-model="currentValue" show-if-above :width="300" :breakpoint="0" bordered>
    <div class="_DevTools">
      <CTitle large class="_DevTools-Title">
        Dev Tools
        <Button
          color="negative"
          flat
          size="sm"
          rounded
          icon="cached"
          tooltip="Reset all parameters"
          :tooltipDelay="10"
          :loading="loadingReset"
          class="ml-xxs"
          @click="onClickReset"
        />
        <template v-slot:right-contents>
          <Toggle v-model="currentIsEnabled" />
        </template>
      </CTitle>

      <Tabs v-model="tab" :items="tabItems" dense />

      <TabPanels :value="tab">
        <TabPanel name="general">
          <DevToolGeneral :disabled="!isEnabled" />
        </TabPanel>

        <TabPanel name="flags">
          <DevToolFlags :disabled="!isEnabled" />
        </TabPanel>

        <TabPanel name="rbac" no-padding>
          <DevToolRbac :disabled="!isEnabled" />
        </TabPanel>

        <TabPanel name="wave_functions">
          <DevToolFunctions :disabled="!isEnabled" />
        </TabPanel>
      </TabPanels>
    </div>
  </q-drawer>
</template>

<script>
import Vue from 'vue';
import Cookies from 'js-cookie';

import Tabs from '@design-system/components/Tabs.vue';
import TabPanels from '@design-system/components/TabPanels.vue';
import TabPanel from '@design-system/components/TabPanel.vue';
import Button from '@design-system/components/Button.vue';
import Toggle from '@design-system/components/Toggle.vue';

import CTitle from '@/components/uikit/CTitle';
import CSection from '@/components/uikit/CSection';
import CSelector from '@/components/uikit/CSelector';

import DevToolGeneral from '@/layouts/DevToolGeneral';
import DevToolFlags from '@/layouts/DevToolFlags';
import DevToolRbac from '@/layouts/DevToolRbac';
import DevToolFunctions from '@/layouts/DevToolFunctions';
import { mapActions, mapState } from 'vuex';
import { sleeper } from '@/lib/tools';

export default Vue.extend({
  name: 'DevTool',
  components: {
    CSection,
    CSelector,
    Tabs,
    TabPanels,
    TabPanel,
    Button,
    Toggle,
    CTitle,
    DevToolGeneral,
    DevToolFlags,
    DevToolRbac,
    DevToolFunctions,
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      tab: 'general',
      tabItems: [
        { label: 'General', value: 'general' },
        { label: 'Flags', value: 'flags' },
        { label: 'RBAC', value: 'rbac' },
        { label: 'Wave Func', value: 'wave_functions' },
      ],

      // Reset
      loadingReset: false,
    };
  },
  created() {
    const isEnabled = Cookies.get('wave-devtools-enabled');
    if (isEnabled === 'true') {
      this.changeIsEnabled(true);
    } else {
      this.changeIsEnabled(false);
    }
  },
  computed: {
    ...mapState('devTools', {
      isEnabled: state => state.isEnabled,
    }),

    currentIsEnabled: {
      get() {
        return this.isEnabled;
      },
      set(value) {
        this.changeIsEnabled(value);
      },
    },

    currentValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...mapActions('devTools', ['changeIsEnabled', 'reset']),

    async onClickReset() {
      this.loadingReset = true;
      await sleeper(1000);
      await this.reset();
      this.loadingReset = false;
    },
  },
});
</script>

<style lang="scss" scoped>
._DevTools {
  &-Title {
    padding: $space-sm;
  }
}
</style>
